import {
  SHOW_FLYOUT,
  HIDE_FLYOUT,
  CLEAN_FILTERS,
  SHOW_ALERT,
  HIDE_ALERT,
  SET_FLYOUT_TITLE,
} from './actionTypes';

export const showFlyout = target => ({ type: SHOW_FLYOUT, target });
export const hideFlyout = target => ({ type: HIDE_FLYOUT, target });
export const setFlyoutTitle = title => ({ type: SET_FLYOUT_TITLE, title });

export const showAlert = props => ({ type: SHOW_ALERT, props });
export const hideAlert = () => ({ type: HIDE_ALERT });

export const cleanFilters = () => ({ type: CLEAN_FILTERS });
